import { FlexibleContent } from './FlexibleContent';

export type { TypeFlexibleContentProps } from './types';
export default FlexibleContent;
